export const errorsMessage = {
  406: 'No se encontraron Drivers cerca de la ruta',
  993: 'Parametro invalido',
  403: 'No es un usuario registrado',
  421: 'Tipo de servicio no disponible en la zona',
  991: 'Algo salio mal',
  995: 'Ya posees un viaje en curso',
  451: 'token invalido',
  435: '',
  904: 'El módulo de desarrollo no está habilitado para tu cuenta',
  980: 'Saldo insuficiente para realizar el viaje',
  981: 'Saldo insuficiente para adquirir prime',
  1152: 'No hay asientos Prime suficientes disponibles.',
  1153: 'Asientos no encontrados', //Batch not found
  1199: 'Ha ocurrido un error. Por favor, intente nuevamente más tarde.',
  1155: 'Debe proporcionar al menos la cantidad mínima de asientos para el precio especial.',
  1156: 'No se puede desasignar el servicio Prime del usuario.',
  // Copy provisional: el definitivo lo define producto (CORP-592).
  1180: 'Tu panel está suspendido. Contacta a soporte para más información.',
  // Registro v2 (CORP-592)
  1181: 'El código es inválido o venció. Solicita uno nuevo.',
  1182: 'Este correo ya tiene una cuenta. Inicia sesión.',
  1183: 'Tu verificación de correo venció. Verifica tu correo de nuevo.',
  1184: 'Esta verificación de correo ya fue usada. Verifica tu correo de nuevo.',
  // Acción bloqueada de un panel pendiente por verificación (CORP-599).
  // Copy provisional.
  1185: 'Verifica tu panel para realizar esta acción.',
  // Token del SDK de verificación de Legal (CORP-598 / CORP-599).
  1186: 'Los datos de tu registro no coinciden con el trámite de verificación. Contacta a soporte para corregirlos.',
  1187: 'Los datos de tu registro no coinciden con el trámite de verificación. Contacta a soporte para corregirlos.',
  1188: 'Tu panel ya está verificado.',
  1189: 'Ya tienes un trámite de verificación en curso.',
  1190: 'La verificación no está disponible en este momento. Intenta de nuevo en unos minutos.',
  1191: 'El RIF de tu registro no es válido. Contacta a soporte para corregirlo.',
  1192: 'Solo el dueño o un super administrador del panel puede completar la verificación.',
};

export const INSUFFICIENT_PRIME_SEATS_ERROR_MESSAGE = errorsMessage[1152];
export const BATCH_NOT_FOUND_ERROR_MESSAGE = errorsMessage[1153];
export const MISSMATCH_SPECIAL_PRICING_ERROR_MESSAGE = errorsMessage[1155];

export const SUSPENDED_PANEL_ERROR_CODE = '1180';

// Panel `pending` sin `allow_operations`: HTTP 400 con `can_verify` en
// `response`. Lo intercepta `ApiRest` y abre el modal o el aviso.
export const PANEL_PENDING_VERIFICATION_ERROR_CODE = '1185';

// Registro v2. El teléfono y el correo de contacto pueden repetirse; 1182 es
// solo para el correo del usuario (el verificado por OTP), con `info.key` 'email'.
export const REGISTER_ERROR_CODES = {
  INVALID_OTP: '1181',
  EMAIL_HAS_ACCOUNT: '1182',
  INVALID_REGISTRATION_TOKEN: '1183',
  USED_REGISTRATION_TOKEN: '1184',
  // `existing_password` falta o no coincide. No consume el token.
  WRONG_EXISTING_PASSWORD: '1194',
};

// Errores de `POST /v1/corporate/auth/legal/sdk-token` (CORP-598).
export const LEGAL_SDK_TOKEN_ERROR_CODES = {
  DATA_MISMATCH: '1186',
  VALIDATION_FAILED: '1187',
  ALREADY_ACTIVE: '1188',
  NEW_VERIFICATION_NOT_ALLOWED: '1189',
  SERVICE_UNAVAILABLE: '1190',
  RIF_INVALID: '1191',
  NOT_ALLOWED: '1192',
};
